import React from 'react';
import TopNav from 'go/components/layout/topNav';
import Footer from 'go/components/static/footer';

export default class PageWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const Render = this.props.pageType;
    return (
      <React.Fragment>
        <TopNav />
        <Render {...this.props} />
        {!this.props.hideFooter && <Footer />}
      </React.Fragment>
    );
  }
}
